<template>
  <div class="no-company-wrapper">
    <div class="content">
      <!-- Logo -->
      <img
        src="../../../assets/logoarquimarket.png"
        alt="Logo"
        class="logo"
      />

      <p class="font-weight-normal title mb-0">Bienvenido</p>
      <p class="font-weight-bold username">{{ username }}</p>

      <p class="description">
        Actualmente tu cuenta no tiene acceso a ninguna empresa.
      </p>

      <p class="details">
        Para continuar, puedes <b>crear una nueva empresa</b> o esperar a que un administrador
        te <b>invite</b> o <b>desbloquee</b> el acceso a una empresa existente.
      </p>

      <div class="actions">
				<v-btn
					color="#524D4D"
					raised
					dark
					@click="$store.commit('companies/setNewCompanyModalFirst', true)"
				>
					<p class="mb-0">Crear Empresa</p>
				</v-btn>
				<v-btn
					depressed
					color="#FF1209"
					dark
					block
					:small="$store.state.menu.sidebarMini"
					@click="logout()"
				>
					<v-icon>mdi-logout</v-icon>
					<p class="mb-0 ml-2 subtitle-2"
					v-show="!$store.state.menu.sidebarMini">Salir de la cuenta</p>
				</v-btn>
      </div>
    </div>
		<CompanyModalFirst v-if="$store.state.companies.newCompanyModalFirst && $store.state.user.userInfo"/>
  </div>
</template>

<script>
import CompanyModalFirst from '@/components/Modals/Company/CompanyModalFirst'

export default {
  name: 'FullScreenNoCompany',
	components: {CompanyModalFirst},
	computed: {
		username() {
			return this.$store.state.user.userInfo?.profile?.name + ' ' + this.$store.state.user.userInfo?.profile?.lastname
		}
	},
	methods: {
		logout(){
			this.$store.commit('user/logoutUser')
			this.$router.push({name: 'Login'})
		}
	}
};
</script>

<style scoped>
.no-company-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fb;
}

.content {
  text-align: center;
  max-width: 420px;
  padding: 24px;
}

.logo {
  width: 120px;
  margin-bottom: 24px;
}

.username {
  font-size: 22px;
  margin-bottom: 12px;
  color: #1f2937;
}

.description {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #374151;
}

.details {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

button {
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.primary {
  background: #2563eb;
  color: white;
  border: none;
}

.secondary {
  background: transparent;
  border: 1px solid #d1d5db;
  color: #374151;
}
</style>
